export const progressSteps = [
  'Download template',
  'Upload file',
  'Initiate user creation',
];
